var _a;
import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
class CustomerBankAccount extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.customerBankAccountId = "";
    }
    pk() {
        return this.customerBankAccountId;
    }
    static listUrl(allParams = {}) {
        const { applicationId, accountNumber, customerNumber } = allParams;
        if (applicationId !== undefined) {
            if (customerNumber !== undefined && accountNumber !== undefined) {
                return `${this.urlRoot}/${customerNumber}/${accountNumber}/${applicationId}`;
            }
            return `${this.urlRoot}/${applicationId}/application`;
        }
        if (customerNumber !== undefined && accountNumber !== undefined) {
            return `${this.urlRoot}/${customerNumber}/${accountNumber}`;
        }
        throw new Error("CustomerBankAccountResource requires applicationId");
    }
}
_a = CustomerBankAccount;
CustomerBankAccount.urlRoot = apiResourceUrl("CustomerBankAccount/");
CustomerBankAccount.urlTemplates = [`${_a.urlRoot}/{applicationId}`];
export { CustomerBankAccount };
//# sourceMappingURL=CustomerBankAccountResource.js.map